export enum SignInViews {
    TWO_FACTOR_AUTH_SCREEN = '2FA',
    LOCK_SCREEN = 'LOCK',
    SIGN_IN_SCREEN = 'SIGN_IN',
}

export const NEW_SIGN_IN_FORM = 'new-sign-in-form';
